if (!customElements.get('guya-ritual')) {
  customElements.define('guya-ritual', class extends HTMLElement {
    connectedCallback() {
      if (this.steps || !Element.prototype.animate || !window.IntersectionObserver) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.steps = [...this.querySelectorAll('[data-ritual-step]')].map(element => ({element, button:element.querySelector('[data-ritual-control]'), animations:[], status:'idle', seen:false, visible:false, userPaused:false, run:0}));
      this.click = event => {
        const step = this.steps.find(item => item.button === event.target.closest('[data-ritual-control]'));
        if (!step || this.motion.matches) return;
        if (step.status === 'playing') {step.userPaused = true; this.pause(step);}
        else if (step.status === 'paused') {step.userPaused = false; this.resume(step);}
        else this.play(step);
      };
      this.preference = () => {
        for (const step of this.steps) {
          if (this.motion.matches) this.stop(step);
          step.button.hidden = this.motion.matches;
        }
      };
      this.visibility = () => this.steps.forEach(step => document.hidden || !step.visible ? this.pause(step) : this.resume(step));
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          const step = this.steps.find(item => item.element === entry.target);
          step.visible = entry.isIntersecting && entry.intersectionRatio >= .45;
          if (step.visible && !this.motion.matches && !document.hidden) {
            if (!step.seen) this.play(step);
            else this.resume(step);
          } else this.pause(step);
        }
      }, {threshold:.45});
      this.steps.forEach(step => {this.update(step);this.observer.observe(step.element);});
      this.addEventListener('click', this.click);
      this.motion.addEventListener('change', this.preference);
      document.addEventListener('visibilitychange', this.visibility);
      this.preference();
    }
    update(step) {
      step.button.dataset.state = step.status;
      const key = step.status === 'playing' ? 'pause' : step.status === 'paused' ? 'resume' : 'replay';
      step.button.textContent = this.dataset[key];
      step.button.setAttribute('aria-label', `${this.dataset[key]}: ${step.element.querySelector('h3').textContent}`);
    }
    play(step) {
      this.stop(step);
      step.seen = true;
      step.userPaused = false;
      const run = ++step.run;
      const frames = {
        spoon:[{transform:'rotate(-15deg)',offset:0},{transform:'rotate(-37deg)',offset:.23},{transform:'rotate(-37deg)',offset:.78},{transform:'rotate(-15deg)',offset:1}],
        'spoon-full':[{opacity:1,offset:0},{opacity:1,offset:.24},{opacity:.7,offset:.4},{opacity:.25,offset:.6},{opacity:0,offset:.74},{opacity:0,offset:1}],
        kettle:[{transform:'rotate(14deg)',offset:0},{transform:'rotate(0deg)',offset:.24},{transform:'rotate(0deg)',offset:.8},{transform:'rotate(14deg)',offset:1}],
        water:[{transform:'scaleY(.05)',opacity:0,offset:0},{transform:'scaleY(.05)',opacity:0,offset:.24},{transform:'scaleY(1)',opacity:1,offset:.34},{transform:'scaleY(1)',opacity:1,offset:.7},{transform:'scaleY(1)',opacity:0,offset:.77},{transform:'scaleY(.05)',opacity:0,offset:1}],
        empty:[{opacity:1,offset:0},{opacity:1,offset:1}],
        bloom:[{opacity:0,offset:0},{opacity:0,offset:.3},{opacity:.38,offset:.48},{opacity:.45,offset:.65},{opacity:0,offset:.94},{opacity:0,offset:1}],
        tea:[{opacity:0,offset:0},{opacity:0,offset:.4},{opacity:.15,offset:.58},{opacity:.48,offset:.8},{opacity:.6,offset:.96},{opacity:.6,offset:1}],
        cup:[{transform:'translateY(0) rotate(0deg)'},{transform:'translateY(-18px) rotate(-5deg)',offset:.38},{transform:'translateY(-18px) rotate(-5deg)',offset:.65},{transform:'translateY(0) rotate(0deg)'}]
      };
      step.animations = [...step.element.querySelectorAll('[data-ritual-part]')].map(element => {
        const part = element.dataset.ritualPart;
        let keyframes = frames[part];
        if (part === 'leaves') {
          const start = .23 + Number(element.dataset.ritualStream) * .025;
          const middle = start + .19;
          const end = start + .38;
          keyframes = [
            {transform:'translateY(-100%)',opacity:0,offset:0},
            {transform:'translateY(-100%)',opacity:0,offset:start},
            {transform:'translateY(-95%)',opacity:1,offset:start+.005},
            {transform:'translateY(100%)',opacity:1,offset:middle-.005},
            {transform:'translateY(100%)',opacity:0,offset:middle},
            {transform:'translateY(-100%)',opacity:0,offset:middle+.001},
            {transform:'translateY(-95%)',opacity:1,offset:middle+.005},
            {transform:'translateY(100%)',opacity:1,offset:end-.005},
            {transform:'translateY(100%)',opacity:0,offset:end},
            {transform:'translateY(100%)',opacity:0,offset:1}
          ];
        }
        return element.animate(keyframes, {duration:4800,easing:part === 'leaves' ? 'linear' : 'ease-in-out',fill:'both',iterations:1});
      });
      step.status = 'playing';
      this.update(step);
      Promise.all(step.animations.map(animation => animation.finished.catch(() => {}))).then(() => {
        if (step.run !== run) return;
        step.status = 'finished';
        this.update(step);
      });
    }
    pause(step) {
      if (step.status !== 'playing') return;
      step.animations.forEach(animation => animation.pause());
      step.status = 'paused';
      this.update(step);
    }
    resume(step) {
      if (step.status !== 'paused' || step.userPaused || this.motion.matches || document.hidden || !step.visible) return;
      step.animations.forEach(animation => animation.play());
      step.status = 'playing';
      this.update(step);
    }
    stop(step) {
      step.run++;
      step.animations.forEach(animation => animation.cancel());
      step.animations = [];
      step.status = 'idle';
      this.update(step);
    }
    disconnectedCallback() {
      if (!this.steps) return;
      this.observer.disconnect();
      this.removeEventListener('click', this.click);
      this.motion.removeEventListener('change', this.preference);
      document.removeEventListener('visibilitychange', this.visibility);
      this.steps.forEach(step => this.stop(step));
      this.steps = null;
    }
  });
}
